var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.specification.value)+"\n  "),(_vm.classifiedIsNew)?_c('NewBadge',{staticClass:"tw-ml-2"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }